import { Inject, Injectable } from '@angular/core';
import { environment } from './environments/environment';
import { Observable, BehaviorSubject, throwError, lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { PayrollResult } from './services/payroll.service';
import { PayrollCycle } from './payroll/payroll.types';
import { CustomerHistory } from './payroll/payroll.types';
import { NzMessageService } from 'ng-zorro-antd/message';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DataserviceService {
  private unsignedTemplatesSubject = new BehaviorSubject<any[]>([]);
  unsignedTemplates$ = this.unsignedTemplatesSubject.asObservable();
  baseUrl = environment.baseUrl;
  baseUrlMarketing = environment.baseUrlMarketing;
  chatServiceBaseUrl = (environment.chatServiceUrl || '').replace(/\/$/, '');
  states = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Virgin Islands', value: 'VI' },
  ];

  constructor(@Inject(HttpClient) private http: HttpClient, @Inject(Router) private _router: Router, private message: NzMessageService) {
  }
  
  signOut() {
    return this.postData({}, 'auth/signout');
  }

  signInWithPhone(phone: string) {

    let formattedPhone = phone.replace(/\D/g, ''); 

    if (formattedPhone.length > 11) {
      formattedPhone = formattedPhone.slice(-11);
    } else if (formattedPhone.length === 10) {
      formattedPhone = '1' + formattedPhone;
    }

    return this.postData({ phone: formattedPhone }, 'auth/otp-phone');
  }

  signInWithEmail(email: string) {
    return this.postData({ email: email }, 'auth/otp-email')
  }

  verifyPhoneOtp(obj: any) {
    return this.postData({ phone: obj.phone, token: obj.otp, type: 'sms' }, 'auth/otp-verify-phone');
  }

  verifyEmailOtp(obj: any) {
    return this.postData({ email: obj.email, token: obj.otp, type: 'email' }, 'auth/otp-verify-email');
  }

  uploadBadgeImg(file: File, filePath: string) {
    const formData = new FormData();
    formData.append('file', file); // The actual File object
    formData.append('path', filePath); // The string path
    return this.postDataBadge(formData, 'auth/upload-badge');
  }

  async deleteBadgeImg(filePath: string | null) {
    if (!filePath) return true;
    return this.postData({ path: filePath }, 'auth/delete-badge');
  }

async uploadFile(fileList: File[]) {
  const formData = new FormData();
  
  // Append all files to the form data
  for (const file of fileList) {
    formData.append('files', file); 
  }

  try {
    const res = await lastValueFrom(
      this.postDataBadge(formData, 'auth/upload-docs')
    );
    
    if (res.result === 'success') {
      return res.path; // Matches your original return of uploadedPaths[0]
    }
    return false;
  } catch (err) {
    console.error('Doc upload failed', err);
    return false;
  }
}

  uploadVideo(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.postDataBadge(formData, 'auth/upload-video');
  }

    async uploadSignedDoc(filePath: string, pdfBlob: Blob) {
      const formData = new FormData();
      // We name the file 'file' so the controller knows what to look for
      // We can also provide a filename as the 3rd argument if needed
      formData.append('file', pdfBlob, 'signed-document.pdf');
      formData.append('path', filePath);

      try {
        const res = await lastValueFrom(
          this.postDataBadge(formData, 'auth/upload-signed-doc')
        );
        
        if (res.result === 'success') {
          return res.data;
        }
        return false;
      } catch (err) {
        console.error('Signed doc upload error', err);
        return false;
      }
  }

  async getSupabaseDoc(filePath: string): Promise<Blob> {
    try {
      const res = await lastValueFrom(
        this.postDataBadge({ path: filePath }, 'auth/get-signed-doc')
      );

      if (res.result === 'success') {
        // Convert Base64 string back to Blob
        const byteCharacters = atob(res.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: res.contentType });
      } else {
        throw new Error(res.message);
      }
    } catch (err) {
      console.error('Download error:', err);
      throw err;
    }
  }

async getSupabaseBadge(filePath: string) {
  // We await the actual HTTP response
  const r: any = await lastValueFrom(
    this.postData({ path: filePath }, 'auth/get-badge')
  );

  if (r.result === 'success') {
    // Convert the Base64 string back into a Blob for the browser
    const byteCharacters = atob(r.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: r.contentType });
  } else {
    throw new Error(r.message);
  }
}

  getAuthToken(): string | null {
    const token = localStorage.getItem('access_token');
    return token;
  }

  getRefreshToken(): string | null {
    return localStorage.getItem('refresh_token');
  }

  postDataBadge(body: any, url: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ` + this.getAuthToken())
      .set('Refresh', '' + this.getRefreshToken())
      .set('Portal-id', JSON.parse(localStorage.getItem('user')!)?.active_portal_id || '');
    return this.http.post(`${this.baseUrl}` + url, body, { headers: headers });
  }

  postData(body: any, url: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ` + this.getAuthToken())
      .set('Refresh', '' + this.getRefreshToken())
      .set('Portal-id', JSON.parse(localStorage.getItem('user')!)?.active_portal_id || '');
    return this.http.post(`${this.baseUrl}` + url, { body: body }, { headers: headers });
  }
  //Put this in cause i can't release dish-api at the moment. This just avoids the backend getting body.body
  postDataNoBodyDotBody(body: any, url: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`)
      .set('Portal-id', JSON.parse(localStorage.getItem('user')!)?.active_portal_id || '');;
  
    return this.http.post(`${this.baseUrl}${url}`, body, { headers });
  }

  getData(endpoint: string, options?: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ` + this.getAuthToken())
      .set('Refresh', '' + this.getRefreshToken())
      .set('Portal-id', JSON.parse(localStorage.getItem('user')!)?.active_portal_id || '');
    return this.http.get<any>(`${this.baseUrl}${endpoint}`, { headers: headers, ...options });
  }

  getFile(endpoint: string): Observable<Blob> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`)
        .set('Portal-id', JSON.parse(localStorage.getItem('user')!)?.active_portal_id || '');;

    return this.http.get(`${this.baseUrl}${endpoint}`, {
      headers,
      responseType: 'blob'
    });
  }

  getMetricsData(url: string, dateRange: [Date, Date]): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ` + this.getAuthToken())
      .set('Refresh', '' + this.getRefreshToken())
      .set('Portal-id', JSON.parse(localStorage.getItem('user')!)?.active_portal_id || '');;
    return this.http.get(`${this.baseUrl}` + url + '?start_date=' + dateRange[0] + '&end_date=' + dateRange[1], { headers: headers });
  }

  getUser(): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ` + this.getAuthToken())
      .set('Refresh', '' + this.getRefreshToken())
    return this.http.get(`${this.baseUrl}` + 'users/me', { headers: headers });
  }

  deleteData(url: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.delete(`${this.baseUrl}${url}`, { headers: headers });
  }

  private buildChatServiceHeaders(): HttpHeaders {
    let headers = new HttpHeaders().set('Content-type', 'application/json');
    const token = this.getAuthToken();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  updateData(data: any, url: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.patch(`${this.baseUrl}${url}`, data, { headers: headers });
  }

  checkUserExists(phone: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}users/exists/${phone}`);
  }

  updateUserMetadata(userId: string, metadata: { [key: string]: any }): Observable<any> {
    return this.postDataBadge(
      { userId, metadata }, 
      'auth/update-metadata'
    );
  }

  calculatePayroll(startDate: Date, endDate: Date): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.post<{ success: boolean; results: PayrollResult[] }>(
      `${this.baseUrl}payplans/calculate`,
      { startDate, endDate },
      { headers }
    );
  }

  getPayrollResults(payplanId: number): Observable<{ results: PayrollResult[] }> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.get<{ results: PayrollResult[] }>(`${this.baseUrl}payplans/results/${payplanId}`, { headers });
  }

  getPayrollHistory(): Observable<PayrollCycle[]> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.get<PayrollCycle[]>(`${this.baseUrl}payplans/cycles`, { headers });
  }

  getGroupedPayrollHistory(isCompanyAdmin: boolean = false): Observable<any[]> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    
    if (isCompanyAdmin) {
      const params = { view: 'company-admin' };
      return this.http.get<any[]>(`${this.baseUrl}payplans/cycles/grouped`, { headers, params });
    } else {
      return this.http.get<any[]>(`${this.baseUrl}payplans/cycles/grouped`, { headers });
    }
  }

  getIndividualPayrollHistory(userId?: string, limit?: number, offset?: number): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    
      const params: any = { view: 'individual' };
      if (userId) {
        params.userId = userId;
      }
      if (typeof limit === 'number') {
        params.limit = String(limit);
      }
      if (typeof offset === 'number') {
        params.offset = String(offset);
      }

      return this.http.get<any>(`${this.baseUrl}payplans/cycles/grouped/individual`, { headers, params });
    
  }

  getCycleCustomerDetails(cycleIds: string | string[], userId: string): Observable<any[]> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    
    // Handle both single cycle ID and array of cycle IDs
    const cycleIdArray = Array.isArray(cycleIds) ? cycleIds : [cycleIds];
    const primaryCycleId = cycleIdArray[0]; // Use first cycle ID in the URL
    const cycleIdsParam = cycleIdArray.join(','); // Pass all cycle IDs as query param
    
    const params = { cycleIds: cycleIdsParam };
    
    return this.http.get<any[]>(`${this.baseUrl}payplans/cycle/${primaryCycleId}/customer-details/${userId}`, { headers, params });
  }

  getHoldbackBank(userId: string) {
    return this.getData(`payplans/holdbacks/user/${userId}`);
  }

  deductHoldback(userId: string, amount: number, reason?: string, notes?: string) {
    return this.post(`payplans/holdbacks/deduct`, { userId, amount, reason, notes });
  }

  // Generic GET with query params helper for admin holdbacks list
  get(endpoint: string, options?: any) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.get(`${this.baseUrl}${endpoint}`, { headers, ...options });
  }

  markPayrollCycleAsPaid(cycleId: string): Observable<PayrollCycle> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.patch<PayrollCycle>(`${this.baseUrl}payplans/cycles/${cycleId}/paid`, {}, { headers });
  }

  markPayrollCycleAsUnpaid(cycleId: string): Observable<PayrollCycle> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.patch<PayrollCycle>(`${this.baseUrl}payplans/cycles/${cycleId}/unpaid`, {}, { headers });
  }

  savePayrollCycle(cycle: Partial<PayrollCycle>): Observable<PayrollCycle> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
      
    return this.http.post<PayrollCycle>(
      `${this.baseUrl}payplans/cycles`,
      cycle,
      { headers }
    );
  }

  patch(endpoint: string, data: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.patch(`${this.baseUrl}${endpoint}`, data, { headers });
  }

  getCustomerCommissionHistory(customerId: string): Observable<CustomerHistory[]> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.get<CustomerHistory[]>(
      `${environment.baseUrl}payplans/customer-commissions/${customerId}`,
      { headers }
    );
  }

  getCustomerPayHistory(customerId: string): Observable<any[]> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.get<any[]>(
      `${environment.baseUrl}payplans/customer-pay-history/${customerId}`,
      { headers }
    );
  }

  getCompanyPayrollDetailedExport(companyId: string, cycleIds: string[]): Observable<any[]> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.post<any[]>(
      `${environment.baseUrl}payplans/company-payroll-detailed-export/${companyId}`,
      { cycleIds },
      { headers }
    );
  }

  post(endpoint: string, data: any) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.post(`${this.baseUrl}${endpoint}`, data, { headers });
  }

  getSystemMessageRules() {
    const headers = this.buildChatServiceHeaders();
    return this.http.get(`${this.chatServiceBaseUrl}/system-messages/rules`, { headers });
  }

  createSystemMessageRule(data: any) {
    const headers = this.buildChatServiceHeaders();
    return this.http.post(`${this.chatServiceBaseUrl}/system-messages/rules`, data, { headers });
  }

  deleteSystemMessageRule(ruleId: string) {
    const headers = this.buildChatServiceHeaders();
    return this.http.delete(`${this.chatServiceBaseUrl}/system-messages/rules/${ruleId}`, { headers });
  }

  updateSystemMessageRule(ruleId: string, data: any) {
    const headers = this.buildChatServiceHeaders();
    return this.http.patch(`${this.chatServiceBaseUrl}/system-messages/rules/${ruleId}`, data, { headers });
  }

  createMessage(type: string, message: string): void {
    // type can be 'success', 'error', or 'warning'
    this.message.create(type, `${message}`);
  }

  impersonateUser(userId: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
      
    return this.http.post(`${this.baseUrl}users/impersonate`, { userId }, { headers }).pipe(
      tap((response: any) => {
        // Assuming the response contains a new token for the impersonated user
        if (response && response.token) {
          localStorage.setItem('access_token', response.token);
          localStorage.setItem('isImpersonating', 'true');
          console.log('Impersonation successful, token updated.');
        } else {
          console.error('Impersonation failed, no token received.');
        }
      }),
      catchError(error => {
        console.error('Error during impersonation:', error);
        return throwError(error);
      })
    );
  }

  isImpersonating(): boolean {
    return localStorage.getItem('isImpersonating') === 'true';
  }

  postMarketing(endpoint: string, data: any) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .set('Authorization', `Bearer ${this.getAuthToken()}`)
      .set('Refresh', `${this.getRefreshToken()}`);
    return this.http.post(`${this.baseUrlMarketing}${endpoint}`, data, { headers });
  }

  getAddress(lat: number, lng: number) {
    const url = `https://api.mapbox.com/search/geocode/v6/reverse?longitude=${lng}&latitude=${lat}&access_token=${environment.mapbox.accessToken}&limit=1`
    // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${environment.mapsKey}`;
    return this.http.get(url);
  }

  getLatLng(address: any) {
    const mapBoxUrl = `https://api.mapbox.com/search/geocode/v6/forward?q=${address}&access_token=${environment.mapbox.accessToken}&limit=1`
     return this.http.get(mapBoxUrl);
  }

  resolveVideoUrl(path: string): Observable<any> {
    return this.postDataBadge({ path }, 'auth/resolve-video-url');
  }
}
